<template>
  <div class="songpagetab">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Bài hát
        </h1>
      </div>

      <div class="right">
        <a
          v-for="tab in tabs"
          v-bind:key="tab.name"
          v-bind:class="['tab-button', { active: currentTab.name === tab.name }]"
          v-on:click="currentTab = tab"
        >{{ tab.name }}</a>
      </div>
    </div>
    <div style="clear: both; margin-bottom: 1rem;"></div>

    <component
      v-bind:is="currentTab.component"
      class="tab"
      :categoryCodeToLastChild = "categoryCodeToChild"
    ></component>
  </div>
</template>

<script>
  import CategorySongMostView from './CategorySongMostView'
  import CategorySongLatest from './CategorySongLatest'

  var tabs = [
    {
      name: "Nghe nhiều",
      component: CategorySongMostView
    },
    {
      name: "Mới nhất",
      component: CategorySongLatest
    }
  ];
  export default {
    name: "Tab",
    props: {
      categoryCodeToChild: String
    },
    data () {
      return {
        tabs: tabs,
        currentTab: tabs[0]
      }
    }
  }
</script>

<style scoped>
  .tab-button{
    background-color: #ccc;
    padding: 0.3rem 1rem;
    font-weight: bold;
  }
  .tab-button:first-child{
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
  .tab-button:last-child{
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .tab-button.active{
    background-color: #00a4e9;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/song/web/Tab.vue